import React from 'react';
import { MapPin } from 'lucide-react';

const CoverageMap = () => {
  return (
    <section className="py-24 bg-slate-900">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Nationwide Coverage
          </h2>
          <p className="text-xl text-gray-400">
            From Bolton to the furthest corners of the UK, we provide reliable 
            vehicle recovery services wherever you need us
          </p>
        </div>

        {/* Coverage Areas */}
        <div className="max-w-6xl mx-auto">
          <div className="bg-slate-950/50 border border-slate-800 rounded-2xl p-12">
            {/* Main Coverage Badge */}
            <div className="text-center mb-12">
              <div className="inline-flex items-center space-x-3 bg-blue-600/20 backdrop-blur-sm border border-blue-500/30 rounded-full px-8 py-4">
                <MapPin className="w-8 h-8 text-blue-500" />
                <span className="text-2xl font-bold text-white">Full UK Coverage</span>
              </div>
            </div>

            {/* Coverage Grid */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
              {[
                'Greater Manchester',
                'Lancashire',
                'Yorkshire',
                'Merseyside',
                'Cheshire',
                'West Midlands',
                'North West',
                'North East',
                'Scotland',
                'Wales',
                'South West',
                'South East'
              ].map((area, index) => (
                <div 
                  key={index}
                  className="bg-slate-900/50 border border-slate-700 rounded-lg p-4 hover:border-blue-500/50 transition-all duration-200 hover:transform hover:scale-105"
                >
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                    <p className="text-gray-300 font-medium">{area}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Key Information */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center p-6 bg-slate-900/50 rounded-lg">
                <p className="text-3xl font-bold text-blue-500 mb-2">30 mins</p>
                <p className="text-gray-400">Average Response Time</p>
              </div>
              <div className="text-center p-6 bg-slate-900/50 rounded-lg">
                <p className="text-3xl font-bold text-blue-500 mb-2">24/7</p>
                <p className="text-gray-400">Service Availability</p>
              </div>
              <div className="text-center p-6 bg-slate-900/50 rounded-lg">
                <p className="text-3xl font-bold text-blue-500 mb-2">100%</p>
                <p className="text-gray-400">UK Coverage</p>
              </div>
            </div>

            {/* Bottom Text */}
            <div className="text-center mt-12">
              <p className="text-gray-400 text-lg mb-6">
                No matter where you are in the UK, our nationwide network ensures 
                you're never stranded for long
              </p>
              <a 
                href="tel:07803539815"
                className="inline-flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all duration-200 hover:scale-105 shadow-lg hover:shadow-blue-500/50"
              >
                <span>Get Help Now</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoverageMap;
